import {Component, Input} from '@angular/core';

import {SubtitlesService, ViewsService, ZonesService} from "../../core";
import {DHWTileType251} from "../../models";

@Component({
    selector: 'dhw-with-events',
    templateUrl: './dhw-with-events.component.html',
    styleUrls: ['./dhw-with-events.component.scss']
})
export class DhwWithEventsComponent {
    @Input() tile: DHWTileType251;

    constructor(
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }
}
